import { render, staticRenderFns } from "./ModulePanel.vue?vue&type=template&id=f378c630&scoped=true"
import script from "./ModulePanel.vue?vue&type=script&lang=js"
export * from "./ModulePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f378c630",
  null
  
)

export default component.exports